import { useEffect } from 'react';
export default function useClickOutside(_ref) {
  var refs = _ref.refs,
    _ref$unless = _ref.unless,
    unless = _ref$unless === void 0 ? false : _ref$unless,
    onClick = _ref.onClick;
  useEffect(function () {
    var refsAsArray = Array.isArray(refs) ? refs : [refs];
    function handleOutsideClick(e) {
      var allRefsHaveCurrent = refsAsArray.every(function (ref) {
        return !!ref.current;
      });
      var shouldNotExecute = typeof unless === 'function' ? unless(e) : unless;
      if (!allRefsHaveCurrent || shouldNotExecute) {
        return;
      }
      var isOutsideClick = refsAsArray.every(function (ref) {
        return !ref.current.contains(e.target);
      });
      if (isOutsideClick) {
        onClick(e);
      }
    }
    document.addEventListener('mousedown', handleOutsideClick);
    return function () {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [unless, onClick, refs]);
}